
define(
	'TavanoTeam.Custom.CheckoutExt.Shopping'
,   [
		'Cart.Summary.View'
	,	'tavano_cart_summary.tpl'
	,	'SC.Configuration'
	,	'Utils'
	,	'jQuery'
	]
,   function (
	 	CartSummaryView
	,	tavano_cart_summary_tpl
	,	Configuration
	,	Utils
	,	jQuery
	)
{
	'use strict';

	var isCustomCheckout = Configuration.get("CustomCheckoutExt.enabled") || false;
	
	if(isCustomCheckout){
		_.extend(CartSummaryView.prototype, {
			
				template: tavano_cart_summary_tpl

			,	getContext: _.wrap(CartSummaryView.prototype.getContext, function (getContextFn) {
					console.log("CartSummaryViewext");
					var context = getContextFn.apply(this, _.toArray(arguments).slice(1));
					return _.extend(context,{
						customcheckout: true
					});
			})

		});
	}

	return  {
		mountToApp: function mountToApp (container)
		{
			


			
		
		}
	};
});
